import {createContext} from "react";

export const PlatformNavContext = createContext(false)
